import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Combien coûte la livraison ?",
    answer:
      "La livraison est GRATUITE pour toute commande de 59$ et plus ! En dessous, des frais de livraison standard s'appliquent selon votre région au Canada.",
  },
  {
    question: "Quel est le délai de livraison ?",
    answer:
      "Nous expédions sous 1 à 3 jours ouvrables. La livraison prend généralement entre 5 et 10 jours ouvrables partout au Canada.",
  },
  {
    question: "Quelle est la qualité des adhésifs ?",
    answer:
      "Nos adhésifs sont fabriqués avec des matériaux premium résistants à l'eau et aux UV. L'effet 3D est obtenu grâce à une technologie d'impression en relief qui donne du volume et de la texture à chaque design.",
  },
  {
    question: "Livrez-vous en dehors du Canada ?",
    answer:
      "Pour le moment, nous livrons uniquement au Canada. Nous travaillons à étendre nos livraisons à l'international très bientôt — restez connectés !",
  },
];

export const FAQ = () => {
  return (
    <section className="bg-gradient-to-b from-cream to-card/50 border-t border-primary/10">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-8 h-1 rounded-full bg-gradient-to-r from-primary to-gold" />
            <span className="font-body text-sm text-primary uppercase tracking-wider">
              Besoin d'aide ?
            </span>
          </div>
          <h2 className="text-3xl font-display font-bold mb-8">
            Questions Fréquentes
          </h2>

          <Accordion type="single" collapsible className="space-y-2">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-primary/10 rounded-xl px-5 bg-background/80 backdrop-blur-sm hover:border-primary/25 hover:shadow-soft transition-all duration-300"
              >
                <AccordionTrigger className="text-left font-body font-medium hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-body text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-8 p-5 rounded-xl bg-gradient-to-r from-primary/10 via-gold/10 to-primary/10 border border-primary/15 text-center relative overflow-hidden shadow-soft">
            <div className="absolute top-2 left-3 text-lg opacity-40">🇹🇳</div>
            <div className="absolute top-2 right-3 text-lg opacity-40">🍁</div>
            <p className="font-body text-sm text-foreground">
              🚚 <span className="font-semibold">Livraison gratuite</span> pour
              toute commande de{" "}
              <span className="font-semibold text-primary">59$ et plus</span> !
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
